import * as React from 'react';
import { CPPart } from '../models/CPPart'
import { Collapse } from 'react-bootstrap';
import { CPReactMethods } from '../app';
import { useState } from 'react';

export interface AssignmentBuilderPartItemProps {
    part: CPPart
    problemIndex: number
    partIndex: number
    partsLength: number
    showEquations: boolean
    answeredInAssignment: boolean
    defaultPointValue: number
    defaultMaxAttempts: number
    defaultUnpenalizedAttempts: number
    defaultPenalty: number
    defaultPlusMinus: number
    defaultPlusMinusIsPercent: boolean
    isGlobalAdmin: Function
    changePointValue: Function
    changeMaxAttempts: Function
    changeUnpenalizedAttempts: Function
    changePenalty: Function
    changePlusMinus: Function
    changePlusMinusIsPercent: Function
}

const AssignmentBuilderPartItem = (props: AssignmentBuilderPartItemProps) => {
    const [hideConfig, setHideConfig] = useState(true)

    return (
        <li className="mb-3" style={{ listStyle: props.partsLength > 1 ? "" : "none" }}>
            <div className="row">
                <div className="col" dangerouslySetInnerHTML={{ __html: props.part.text || "" }}></div>

            </div>
            <div className="row">
                {props.part.multipleChoice ?
                    <>
                        <div className="col-auto" dangerouslySetInnerHTML={{ __html: props.part.answerLabel }}>
                        </div>
                        <div className="col-auto">
                            {props.part.options ?
                                props.part.options.map((option, optionIndex) => {
                                    return (
                                        <div className="form-check" key={optionIndex}>
                                            <input role="button" className="form-check-input" type="radio" checked={false} onChange={() => { }} />
                                            <label className="form-check-label">{option.text}</label>
                                        </div>
                                    )
                                }) : ""}
                        </div>
                        <div className="col-auto" dangerouslySetInnerHTML={{ __html: props.part.unitsLabel }}>
                        </div>
                    </>
                    /* Creates a select box
                    <select className="form-select" value={answers[problemIndex].parts[partIndex].attempts[answers[problemIndex].parts[partIndex].attempts.length - 1].answer} onChange={e => changeAnswer(problemIndex, partIndex, e.currentTarget.value)}>
                        {part.options.map(option => {
                            return (
                                <option key={option.text} value={option.value}>{option.text}</option>
                            )
                        })}
                    </select>*/

                    :
                    <div className="col-auto">
                        <div className="input-group">
                            {!CPReactMethods.isNullOrWhiteSpace(props.part.answerLabel) ?
                                <span className="input-group-text px-1">
                                    <p className="mb-0" dangerouslySetInnerHTML={{ __html: props.part.answerLabel }}>
                                    </p>
                                </span> : ""}
                            <input type="text" className="form-control answerInput" value="" onChange={() => { }} />
                            {props.part.scientificNotation ?
                                <>
                                    <span className="input-group-text px-1">
                                        x10^
                                    </span>
                                    <input type="text" className="form-control exponentInput" value="" onChange={() => { }} />
                                </> : ""}
                            {!CPReactMethods.isNullOrWhiteSpace(props.part.unitsLabel) ?
                                <span className="input-group-text px-1">
                                    <p className="mb-0" dangerouslySetInnerHTML={{ __html: props.part.unitsLabel }}>
                                    </p>
                                </span> : ""}
                        </div>
                    </div>
                }
                {props.showEquations ?
                    <>
                        <div className="col">
                            Equation:&nbsp;
                            {props.part.equation}
                        </div>
                    </> : ""}
                {props.isGlobalAdmin() ? "" :
                    <div className="col-auto">
                        <button type="button" className="btn btn-primary" onClick={() => setHideConfig(!hideConfig)}>
                            {hideConfig ? "Show Scoring Customization" : "Hide Scoring Customization"}
                            {props.part.points != null || props.part.maxAttempts != null || props.part.unpenalizedAttempts != null || props.part.penalty != null || props.part.plusMinus != null || props.part.plusMinusIsPercent != null ?
                                "*" : ""}
                        </button>
                    </div>
                }
            </div>
            <Collapse in={!hideConfig}>
                <div className="row justify-content-center text-center">
                    {!props.isGlobalAdmin() ?
                        <>
                            <div className="col-auto m-1">
                                Points
                                <div className="row">
                                    <input type="number" min="0" className="form-control form-control-sm text-center col partField" data-problemindex={props.problemIndex} data-partindex={props.partIndex} onChange={e => props.changePointValue(e.currentTarget)} value={props.part.points != undefined ? props.part.points : props.defaultPointValue} />
                                    {props.part.points == undefined ? "" : <b className="col-auto p-0 mx-1">*</b>}
                                </div>
                            </div>
                            <div className="col-auto m-1">
                                Max Attempts
                                <div className="row">
                                    <input disabled={props.answeredInAssignment} type="number" min="0" className="form-control form-control-sm text-center col partField" data-problemindex={props.problemIndex} data-partindex={props.partIndex} onChange={e => props.changeMaxAttempts(e.currentTarget)} value={props.part.maxAttempts != undefined ? props.part.maxAttempts.toString() : props.defaultMaxAttempts.toString()} />
                                    {props.part.maxAttempts == undefined ? "" : <b className="col-auto p-0 mx-1">*</b>}
                                </div>
                            </div>
                            <div className="col-auto m-1">
                                Unpenalized Attempts
                                <div className="row">
                                    <input disabled={props.answeredInAssignment} type="number" min="0" className="form-control form-control-sm text-center col partField" data-problemindex={props.problemIndex} data-partindex={props.partIndex} onChange={e => props.changeUnpenalizedAttempts(e.currentTarget)} value={props.part.unpenalizedAttempts != undefined ? props.part.unpenalizedAttempts.toString() : props.defaultUnpenalizedAttempts.toString()} />
                                    {props.part.unpenalizedAttempts == undefined ? "" : <b className="col-auto p-0 mx-1">*</b>}
                                </div>
                            </div>
                            <div className="col-auto m-1">
                                Penalty %
                                <div className="row">
                                    <input disabled={props.answeredInAssignment} type="number" min="0" className="form-control form-control-sm text-center col partField" data-problemindex={props.problemIndex} data-partindex={props.partIndex} onChange={e => props.changePenalty(e.currentTarget)} value={props.part.penalty != undefined ? props.part.penalty : props.defaultPenalty} />
                                    {props.part.penalty == undefined ? "" : <b className="col-auto p-0 mx-1">*</b>}
                                </div>
                            </div>
                            <div className="col-auto m-1">
                                Error Allowance
                                <div className="row">
                                    <div className="col-auto px-0">
                                        <input disabled={props.answeredInAssignment} type="number" min="0" className="form-control form-control-sm text-center col partField" data-problemindex={props.problemIndex} data-partindex={props.partIndex} onChange={e => props.changePlusMinus(e.currentTarget)} value={props.part.plusMinus != undefined ? props.part.plusMinus : props.defaultPlusMinus} />
                                    </div>
                                    <div className="col-auto px-0">
                                        <select disabled={props.answeredInAssignment} className="form-select form-select-sm" data-problemindex={props.problemIndex} data-partindex={props.partIndex} onChange={e => props.changePlusMinusIsPercent(e.currentTarget)} value={props.part.plusMinusIsPercent != undefined ? props.part.plusMinusIsPercent.toString() : props.defaultPlusMinusIsPercent.toString()}>
                                            <option value={undefined}>Default</option>
                                            <option value={"true"}>%</option>
                                            <option value={"false"}>{props.part.unitsLabel ? props.part.unitsLabel : "Units"}</option>
                                        </select>
                                    </div>
                                    {props.part.plusMinus == undefined && props.part.plusMinusIsPercent == undefined ? "" : <div className="col-1"><b className="col-auto p-0 mx-1">*</b></div>}
                                </div>
                            </div>
                        </>
                        : ""}
                </div>
            </Collapse>
        </li>

    );
};

export default AssignmentBuilderPartItem;